const mutations = {
    setServiceCategory(state, data) {
        state.serviceCategory = data;
    },
    setServiceCategoryList(state, data) {
        state.serviceCategoryList = data;
    },
    resetServiceCategory(state) {
        state.serviceCategory = {
            label: '',
            letter: ''

        }
    }
}
export default mutations;